const updateLanguage = {
  'update-language-submitting-form': 'Changing language. Please wait...',
  'update-language-submit-button': 'Change Language',
  'update-language-title': 'In which language would you like to receive the newsletter?',
  'update-language-success-message': 'The language in which you will receive the newsletter has been successfully changed'
};

export default updateLanguage;
